/* eslint-disable react/jsx-no-constructed-context-values */
import React, { createContext, useContext, useState } from 'react'

const FormContext = createContext(null)
interface FormProviderProps {
  children: React.ReactNode,
  initialValues: Object
}

const Form: React.FC<FormProviderProps> = ({ children, initialValues }) => {

  const [fields, setFields] = useState<any>(initialValues)

  const [errors, setErrors] = useState<any>({ message: '', isInvalid: false })

  const handleFieldChange = event => {
    const { name, value } = event.target

    setFields({
      ...fields,
      [name]: value,
    })
  }

  const handleFieldError = (event, error = {message: '', isInvalid: false}): void => {
    const { name } = event.target
    setErrors({
      ...errors,
      [name]: { message: error.message, isInvalid: error.isInvalid },
    })
  }

  const store = {
    fields,
    setFields,
    errors,
    setErrors,
    handleFieldError,
    handleFieldChange,
  }

  return (
    <FormContext.Provider value={store}>{children}</FormContext.Provider>
  )
}

export const useFormContext = () => {
  const context = useContext(FormContext)
  if (context === undefined) {
    throw new Error('useFormContext must be used within a FormProvider')
  }
  return context
}

export default Form
